export default __webpack_public_path__ + "static/media/close-grey.ee4d8941.svg";